import React, { useEffect, useState } from "react";
import { Button, Card, Form, Row, Col } from "react-bootstrap";
import {
  getYhteyshenkilotByKiinteistoId,
  createYhteyshenkilot,
  updateYhteyshenkilot,
  deleteYhteyshenkilot
} from "../api/api.js";
import { FaTrash, FaPlus, FaEdit, FaSave, FaTimes, FaCheck } from "react-icons/fa";

const TITTELI_OPTIONS = ["Isännöitsijä", "Puheenjohtaja", "Talonmies"];

export default function YhteyshenkilotTab({
  id_kiinteisto,
  onSelectContact,
  onReport = false
}) {
  const [yhteyshenkilot, setYhteyshenkilot] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [tempContact, setTempContact] = useState({});
  const [showNewContact, setShowNewContact] = useState(false);
  const [newContact, setNewContact] = useState({
    etunimi: "",
    sukunimi: "",
    sposti: "",
    puhelin: "",
    yritys: "",
    titteli: "",
    rooli: "",
    selite: ""
  });

  const fields = [
    { key: "etunimi", label: "Etunimi" },
    { key: "sukunimi", label: "Sukunimi" },
    { key: "sposti", label: "Sähköposti" },
    { key: "puhelin", label: "Puhelin" },
    { key: "yritys", label: "Yritys" },
    { key: "titteli", label: "Titteli", options: TITTELI_OPTIONS },
    { key: "rooli", label: "Rooli" },
    { key: "selite", label: "Selite" }
  ];

  useEffect(() => {
    if (id_kiinteisto) loadYhteyshenkilot();
  }, [id_kiinteisto]);

  const loadYhteyshenkilot = async () => {
    try {
      const { data } = await getYhteyshenkilotByKiinteistoId(id_kiinteisto);
      setYhteyshenkilot(data);
    } catch (err) {
      console.error("Failed to load contacts:", err);
    }
  };

  const handleEditRow = (contact) => {
    setEditingId(contact.id_yhteyshenkilo);
    setTempContact({ ...contact });
  };

  const handleCancelEdit = () => {
    setEditingId(null);
    setTempContact({});
  };

  const handleSaveRow = async () => {
    try {
      const { id_yhteyshenkilo, ...updates } = tempContact;
      const { data } = await updateYhteyshenkilot(id_yhteyshenkilo, updates);
      setYhteyshenkilot((prev) =>
        prev.map((c) => (c.id_yhteyshenkilo === id_yhteyshenkilo ? data : c))
      );
      setEditingId(null);
      setTempContact({});
    } catch (err) {
      console.error("Failed to update contact:", err);
    }
  };

  const handleDeleteContact = async (id, name) => {
    const confirmed = window.confirm(`Haluatko varmasti poistaa yhteyshenkilön ${name}?`);
    if (!confirmed) return;

    try {
      await deleteYhteyshenkilot(id);
      setYhteyshenkilot((prev) => prev.filter((c) => c.id_yhteyshenkilo !== id));
    } catch (err) {
      console.error("Failed to delete contact:", err);
    }
  };

  const handleCreateContact = async () => {
    try {
      const payload = { ...newContact, id_kiinteisto };
      const { data } = await createYhteyshenkilot(payload);
      setYhteyshenkilot((prev) => [...prev, data]);
      setNewContact({
        etunimi: "",
        sukunimi: "",
        sposti: "",
        puhelin: "",
        yritys: "",
        titteli: "",
        rooli: "",
        selite: ""
      });
    } catch (err) {
      console.error("Failed to create contact:", err);
    }
  };

  return (
    <div className="mt-3">
      {/* New Contact */}

            <div className="mb-3">
            {!showNewContact ? (
                <Button
                variant="outline-success"
                onClick={() => setShowNewContact(true)}
                >
                <FaPlus className="me-1" /> Lisää uusi yhteyshenkilö
                </Button>
            ) : null}
            </div>

            {/* 🔽 Conditional New Contact Form */}
            {showNewContact && (
            <Card className="mb-4 border-success shadow-lg bg-success bg-opacity-10">
                <Card.Body>
                <h5 className="text-success fw-bold mb-3">Uusi yhteyshenkilö</h5>
                <Row className="align-items-end">
                    {fields.map((f) => (
                    <Col key={f.key} md={3} sm={6} className="mb-2">
                        <Form.Control
                        size="sm"
                        type="text"
                        list={f.key === "titteli" ? "titteli-options" : undefined}
                        placeholder={f.label}
                        value={newContact[f.key]}
                        onChange={(e) =>
                            setNewContact({ ...newContact, [f.key]: e.target.value })
                        }
                        />
                    </Col>
                    ))}
                    <Col md="auto" sm={12} className="d-flex gap-2">
                    <Button variant="success" onClick={handleCreateContact}>
                        <FaSave /> Tallenna
                    </Button>
                    <Button
                        variant="secondary"
                        onClick={() => setShowNewContact(false)}
                    >
                        <FaTimes /> Peruuta
                    </Button>
                    </Col>
                </Row>
                </Card.Body>
            </Card>
            )}

      {/* Contact Cards */}
        <Row xs={1} md={2} lg={3} className="g-3">
        {yhteyshenkilot.map((contact) => {
            const isEditing = editingId === contact.id_yhteyshenkilo;

            return (
            <Col key={contact.id_yhteyshenkilo}>
                <Card className="shadow-sm border-success h-auto">
                <Card.Header className="bg-success text-white fw-bold">
                    {isEditing ? (
                    <Form.Control
                        size="sm"
                        type="text"
                        list="titteli-options"
                        value={tempContact.titteli}
                        onChange={(e) =>
                        setTempContact({ ...tempContact, titteli: e.target.value })
                        }
                    />
                    ) : (
                    contact.titteli || "Ei titteliä"
                    )}
                </Card.Header>

                <Card.Body className="p-2">
                    {fields
                    .filter((f) => f.key !== "titteli")
                    .map((f) => (
                        <Form.Group key={f.key} className="mb-1">
                        <Form.Label className="small fw-bold text-success mb-0">
                            {f.label}
                        </Form.Label>
                        {isEditing ? (
                            <Form.Control
                            size="sm"
                            type="text"
                            value={tempContact[f.key]}
                            onChange={(e) =>
                                setTempContact({
                                ...tempContact,
                                [f.key]: e.target.value
                                })
                            }
                            />
                        ) : (
                            <div className="small">{contact[f.key]}</div>
                        )}
                        </Form.Group>
                    ))}
                </Card.Body>

                <Card.Footer className="d-flex justify-content-end gap-1 p-2">
                    {isEditing ? (
                    <>
                        <Button variant="success" size="sm" onClick={handleSaveRow}>
                        <FaSave />
                        </Button>
                        <Button variant="secondary" size="sm" onClick={handleCancelEdit}>
                        <FaTimes />
                        </Button>
                    </>
                    ) : (
                    <>
                        {onReport && (
                        <Button
                            variant="success"
                            size="sm"
                            onClick={() => onSelectContact && onSelectContact(contact)}
                            >
                            <FaCheck className="me-1" /> Valitse toimeksiantajaksi
                        </Button>
                        )}
                        <Button
                        variant="outline-success"
                        size="sm"
                        onClick={() => handleEditRow(contact)}
                        >
                        <FaEdit />
                        </Button>
                        <Button
                        variant="outline-danger"
                        size="sm"
                        onClick={() =>
                            handleDeleteContact(
                            contact.id_yhteyshenkilo,
                            `${contact.etunimi} ${contact.sukunimi}`
                            )
                        }
                        >
                        <FaTrash />
                        </Button>
                    </>
                    )}
                </Card.Footer>
                </Card>
            </Col>
            );
        })}
        </Row>

      <datalist id="titteli-options">
        {TITTELI_OPTIONS.map((opt) => (
          <option key={opt} value={opt} />
        ))}
      </datalist>

      <style>{`
        .card {
          transition: transform 0.15s ease, box-shadow 0.15s ease;
        }
        .card:hover {
          transform: translateY(-3px);
          box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.2);
        }
      `}</style>
    </div>
  );
}
